import * as React from "react";
import { Input as InputPrimitive } from "@base-ui/react/input";

import { cn } from "@/lib/utils";

function Input({
  className,
  type,
  appearance = "default",
  ...props
}: React.ComponentProps<"input"> & {
  /** `bare`: a picker's search row (§7.1), borderless; the row's divider marks it. */
  appearance?: "default" | "form" | "compact" | "bare";
}) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        "h-8 w-full min-w-0 rounded-lg border border-input bg-transparent px-2.5 py-1 text-base transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
        appearance === "form"
          ? "h-9 rounded-md bg-background text-compact max-sm:text-base dark:bg-background"
          : appearance === "compact"
            ? "h-[30px] rounded-md bg-background px-2.5 text-compact max-sm:h-9 max-sm:text-base md:text-compact dark:bg-background"
            : appearance === "bare"
              ? "h-9 rounded-none border-0 bg-transparent px-0 text-compact shadow-none focus-visible:ring-0 max-sm:h-11 max-sm:text-base dark:bg-transparent"
              : "md:text-sm",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
